import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class Breadcrumb2 extends Component {
    render (){
        const {title, parent} = this.props;
        return (
            <div className="breadcrumb-section title-cart">
                <div className="container">
                    {/*<div className="row">
                        <div className="col-md-12">
                            <div className="page-title page-credit">
                                <label className="text-credit">CREDITO ACUM. S/ 300.00 </label>
                            </div>
                        </div>
                    </div>*/}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-title page-tittle2">
                                {/*<h1>{title}</h1>*/}
                                <label className="text-confirm-order">CONFIRMA TU PEDIDO.</label>
                            </div>
                        </div>
                        {/*<div className="col-md-6">
                            <nav aria-label="breadcrumb" className="theme-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}`}>Home</Link></li>
                                    {parent?
                                    <li className="breadcrumb-item" aria-current="page">{parent}</li>:''}
                                    <li className="breadcrumb-item active" aria-current="page">{title}</li>
                                </ol>
                            </nav>
                        </div>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default Breadcrumb2;